import React, { useState, useEffect } from "react";
import {Box, Button, createTheme, Grid, IconButton, InputBase, Tab, Table, TableBody, TableCell, TableHead, TableRow, ThemeProvider, Typography} from '@material-ui/core';
import {useHistory} from 'react-router-dom';
import useStyles from '../../assets/styles';
import { getBackgroundColor, getColor } from "src/app/utils";
import { DropDown } from "../components/DropDown";

export const StatusMappingComponent = ({devicePulseStatus, jiraStatuses, increaseStep, decreaseStep, handleJiraStatusChange, statusMapping, setStatusMapping, mappingErrors, isServiceNow}) => {
    const theme = createTheme({
        typography: {
            fontFamily: "'Poppins', sans-serif",
        },
    });
    const classes = useStyles();
    return(
        <ThemeProvider theme={theme}>
                    <div>
                        <Grid container className={classes.root} style={{justifyContent:"center"}}>
                            <Grid item xs={7} md={7}>
                                <Grid container className={classes.formContent}>
                                    <Grid container className={classes.dataStreamBoxContainer}>
                                        <Table className={classes.tableContainer} style={{border: '1px solid #E2E5ED', width:'100%'}}>
                                            <TableHead>
                                                <TableRow style={{backgroundColor:'white'}}>
                                                <TableCell>DevicePulse Status</TableCell>
                                                <TableCell>{isServiceNow ? 'ServiceNow' : 'Jira'} Status</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {isServiceNow ? (
                                                    devicePulseStatus.map((data, index) => {
                                                        const selectedStatus = statusMapping[index];
                                                        const selectedOption = jiraStatuses.find(s => s.label === selectedStatus);
                                                    return (
                                                        <TableRow key={index} style={{backgroundColor: index % 2 === 0 ? '#F5F5F5' : 'white'}}>
                                                        <TableCell>
                                                            <Box display="flex" className={classes.jiraStatus} 
                                                            style={{
                                                                color: getColor(data.status), 
                                                                backgroundColor: getBackgroundColor(data.status), 
                                                                width: "fit-content"
                                                            }}>
                                                            {data.status}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell>
                                                            <DropDown
                                                                options={jiraStatuses.map(status => status.label)}
                                                                type="status"
                                                                emptyTag="Select"
                                                                onClick={(selectedLabel) => handleJiraStatusChange(index, selectedLabel)}
                                                                value={statusMapping[index] || ""}
                                                                isSingle={true}
                                                            />
                                                            
                                                            {mappingErrors[index] && (
                                                            <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                                {mappingErrors[index]}
                                                            </div>
                                                            )}
                                                        </TableCell>
                                                        </TableRow>
                                                    );
                                                    })
                                                ) : (
                                                    devicePulseStatus.map((data, index) => (
                                                    <TableRow key={index} style={{backgroundColor: index % 2 === 0 ? '#F5F5F5' : 'white'}}>
                                                        <TableCell>
                                                        <Box display="flex" className={classes.jiraStatus} 
                                                            style={{
                                                            color: getColor(data.status), 
                                                            backgroundColor: getBackgroundColor(data.status), 
                                                            width: "fit-content"
                                                            }}>
                                                            {data.status}
                                                        </Box>
                                                        </TableCell>
                                                        <TableCell>
                                                        <DropDown
                                                            options={jiraStatuses}
                                                            type="status"
                                                            emptyTag="Select"
                                                            onClick={(selected) => handleJiraStatusChange(index, selected)}
                                                            value={statusMapping[index] || ""}
                                                            isSingle={true}
                                                        />
                                                        {mappingErrors[index] && (
                                                            <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                            {mappingErrors[index]}
                                                            </div>
                                                        )}
                                                        </TableCell>
                                                    </TableRow>
                                                    ))
                                                )}
                                                </TableBody>
                                        </Table>
                                        <Grid container spacing={2} style={{ marginTop: "15px" }} justifyContent="flex-end">
                                            <Grid item>
                                                <Button
                                                variant="contained"
                                                className={classes.backButton}
                                                style={{margin: "0px"}}
                                                onClick={decreaseStep}
                                                >
                                                Back
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button
                                                variant="contained"
                                                className={`${classes.devicePulseSaveButton} ${classes.button}`}
                                                onClick={increaseStep}
                                                >
                                                Submit
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                
            </div>
        </ThemeProvider>
    )
}